/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.body.addEventListener('click', ev => {
    if(ev.target.classList.contains('link--more')) {
        ev.preventDefault();
        const btn = ev.target;
        const box = ev.target.closest('.product-meta__description');
		const buybox = box.closest('.product-block-list__item--buybox');
		const wrapper = buybox.closest('.product-block-list');
		
        box.classList.toggle('product-meta__description--collapsed');
	    wrapper.style.setProperty('min-height', `${buybox.offsetHeight}px`);
        if(box.classList.contains('product-meta__description--collapsed')) { 
            btn.innerText = 'Read more';
        } else {
            btn.innerText = 'Show less';
        }
      	
    }
});

$(".slider-wrapper").flickity({
  wrapAround: true,
  pageDots: false,
  initialIndex: 1,
  cellAlign: 'left'
});


let getSticky = document.querySelector('.Quick_Links .section');
if(getSticky){
  let getStickyAttribute = getSticky.getAttribute('data-sticky-enable');
  if(getStickyAttribute=='true'){
    document.querySelector('.Quick_Links').classList.add('Sticky_Links');
  } 
}


/***** HIDE TAX MESSAGING IF FLAGGED *****/
var hideMessageFlag = document.getElementById('hideProductFormMessageFlag');

if (hideMessageFlag) {
    // Add the class to hide the product form message
    document.body.classList.add('hide-product-form-message');
}

/***** QTY SELECTOR *****/
function increaseQuantity(inputId) {
    var inputElement = document.getElementById(inputId);
    var currentQuantity = parseInt(inputElement.value, 10);
    inputElement.value = currentQuantity + 1;
  }

  function decreaseQuantity(inputId) {
    var inputElement = document.getElementById(inputId);
    var currentQuantity = parseInt(inputElement.value, 10);
    inputElement.value = currentQuantity > 1 ? currentQuantity - 1 : 1;
  }


/***** REMOVE H2 TAG FROM PDP PRODUCT TITLE *****/
// Find the element with the class .product-meta__title
var titleElement = document.querySelector('.product-meta__title');

// Check if the element exists before attempting to modify classes
if (titleElement) {
  // Remove the class '.h2' if it exists
  titleElement.classList.remove('h2');

  // Add the class 'h1'
  titleElement.classList.add('h1');
}

/***** APPLY H3 TAG TO PDP PRODUCT SUBTITLE *****/
// Find the element with the class .var-subtitle
var titleElement = document.querySelector('.var-subtitle');

// Check if the element exists before attempting to modify classes
if (titleElement) {

  // Add the class 'h3'
  titleElement.classList.add('h3');
}


// security SEO thing //
document.addEventListener("DOMContentLoaded", function() {
  // Select all links with target="_blank"
  var links = document.querySelectorAll('a[target="_blank"]');
  
  // Loop through each link and add the rel="noreferrer noopener" attribute
  links.forEach(function(link) {
    link.rel = 'noreferrer noopener';
  });
});

// Webinar links were double opening //
document.addEventListener('DOMContentLoaded', function () {
  // Scope this only to card modules
  const cardModules = document.querySelectorAll('.card.card--no-background');

  cardModules.forEach(function (card) {
    const button = card.querySelector('.card__actions a');

    if (button) {
      // Prevent parent card onclick when clicking the button
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault(); // Stop default <a> behavior

        // Force open in a new tab
        window.open(button.href, '_blank');
      });
    }
  });
});
